import { PreventAndRedirectCommands, RedirectResult, Router, RouterLocation } from "@vaadin/router";
import { css, html, LitElement, unsafeCSS } from "lit";
import { customElement, query, state } from "lit/decorators.js";
import { ToasterService } from "se-shared/services/toaster.service";
import { container } from "tsyringe";
import instagram from "../../../assets/instagram.svg";
import linkedin from "../../../assets/linkedin.svg";
import logo from "../../../assets/logo-tagline.svg";
import twitter from "../../../assets/twitter.svg";
import backgroundMaze from "../../../assets/backgroundMaze.png";
import { User } from "../models/user";
import { AppConfigService } from "../services/app-config.service";
import { AuthService } from "../services/auth.service";
import "./components/primary-button.element";
import "./components/secondary-button.element";
import { BaseEditor } from "./editors/base-editor";
import "./editors/input-editor.element";
import { InputEditorElement } from "./editors/input-editor.element";

@customElement("se-reset-password")
export class ResetPasswordElements extends LitElement {
    private _appConfigService: AppConfigService;
    private _toasterService: ToasterService;
    private _authService: AuthService;
    private _email: string;
    private _user: User;
    private _token: string;
    private _currentYear: number;

    @query("#email") private _emailEditor: HTMLLabelElement;
    @query("#password") private _passwordEditor: InputEditorElement;
    @query("#confirmPassword") private _comparePasswordEditor: InputEditorElement;

    @state() private _hasChanged = false;

    constructor() {
        super();

        this._appConfigService = container.resolve(AppConfigService);
        this._toasterService = container.resolve(ToasterService);
        this._authService = container.resolve(AuthService);
        this._currentYear = new Date().getFullYear();
    }

    public async onBeforeEnter(location: RouterLocation, commands: PreventAndRedirectCommands, router: Router): Promise<Promise<unknown> | RedirectResult | undefined> {
        const userId = new URLSearchParams(location.search).get("id");
        if (userId != null) {
            this._token = new URLSearchParams(location.search).get("token");
            await this.ValidateToken(userId, this._token);
        }
        return undefined;
    }

    connectedCallback() {
        super.connectedCallback();
        this.addEventListener("editorChanged", (ev: CustomEvent) => this.onEditorChanged(ev));
    }
    disconnectedCallback() {
        this.addEventListener("editorChanged", (ev: CustomEvent) => this.onEditorChanged(ev));
        super.disconnectedCallback();
    }

    private onEditorChanged(ev) {
        this._hasChanged = true;
    }

    updateChangedValues() {}

    show() {
        this.hidden = false;
    }
    hide() {
        this.hidden = true;
    }

    firstUpdated() {
        /*
        if (this._authService != null) {
            this._emailEditor.innerText = "Email: " +this._authService.user.email;
            //this._emailEditor.value = this._authService.user.email;
            //this._emailEditor.disabled = true;
        }
        */
    }
    private fillDefaults() {}

    private reportValidity(): boolean {
        for (const elem of Array.from(this.shadowRoot.querySelectorAll("*"))) {
            if ((elem as unknown as BaseEditor)?.reportValidity?.() === false) return false;
        }
        return true;
    }

    private async ValidateToken(userId: string, token: string) {
        const res = await this._authService.ValidateToken(userId, token);
        if (res.isOk) {
            this._toasterService.showSuccess("Token Succcesfully verified.");
            this._user = res.value;
            this._email = this._user.email
            //this._emailEditor.innerText = "Email: " + this._user.email;
            //this._emailEditor.value = this._user.email;
        } else {
            return window.location.replace("/login?error=" + res.err.message.replace(/ /g,"+"))
        }
    }

    private async save() {
        if (this.reportValidity()) {
            this._hasChanged = false;
            if (this._token != null) {
                await this._authService
                    .ResetPassword(this._token, this._passwordEditor.liveValue)
                    .then(() => this.success())
                    .catch((err) => this.error(err));
            }
            /*
            else {
                await this._authService.ChangePassword(this._authService.user.id, this._passwordEditor.liveValue)
                    .then(() => this.success()).catch(err => this.error(err));
            }
            */
            //await this._authService.ResetPassword(this._emailEditor.liveValue, this._token, this._passwordEditor.liveValue)
            //    .then(() => this.success()).catch(err=>this.error(err));
        }
    }

    private success() {
        this._toasterService.showSuccess("Password successfully updated. Please use the updated password to login.");
        this._authService.logout();
        Router.go("/login");
        //Router.go("/");
    }
    private async login(ev) {
        ev.preventDefault();
        Router.go("/login");
    }

    private async cancel(ev) {
        ev.preventDefault();
        history.back();
    }

    private error(err: Error) {
        alert(err.message);
        this._hasChanged = true;
    }

    passwordChanged() {
        if (this._passwordEditor.liveValue !== this._comparePasswordEditor.liveValue) {
            this._comparePasswordEditor.setCustomValidity("Passwords don't match.");
        } else {
            this._comparePasswordEditor.setCustomValidity("");
            this._comparePasswordEditor.reportValidity();
        }
    }

    render() {
        return html`
    <form id="editorForm" class="editor">
       <div class="scroll-container">
          <div class="content">
            <div style="text-align: center;margin-bottom: 5px;">
                <img src=${logo} class="header-logo" />
            </div>
            <div>
                <div class="email-container">
                    <label class="email-text" id="email">${this._email ? this._email : html``}</label>
                </div>
                <se-input-editor
                    class="inputEditor"
                    @editorChanged=${this.passwordChanged}
                    id="password"
                    name="password"
                    type="password"
                    label="New Password"
                    labelPosition="top"
                    input-type="password"
                    required
                    size="normal"
                ></se-input-editor>
                <se-input-editor
                    class="inputEditor"
                    @editorChanged=${this.passwordChanged}
                    id="confirmPassword"
                    name="confirmPassword"
                    type="password"
                    label="Confirm Password"
                    labelPosition="top"
                    input-type="password"
                    required
                    size="normal"
                ></se-input-editor>
                <se-primary-button
                    class="inputEditor loginButton"
                    .action="${() => this.save()}"
                    action-delay="500"
                    ?disabled="${!this._hasChanged}"
                    text="Reset Password"
                    position="first"
                    size="normal"
                ></se-primary-button>
                <div class="loginLink">
                    <a href="" class="link" @click="${this.login}">Back to Login</a>
                </div>
            </div>
          </div>
       </div>
    </form>
    <div class="footer">
        <div>
            © ${this._currentYear} Sequentum •
            <a href="https://www.sequentum.com/privacy-policy" target="_blank">Privacy Policy</a> •
            <a href="https://www.sequentum.com/terms-of-service" target="_blank">Terms of Service</a>
        </div>
        <div style="text-align: right; flex:1">
            <a href="https://twitter.com/sequentuminc" target="_blank"><img src=${twitter} /></a>
            <a href="https://www.linkedin.com/company/sequentum/" target="_blank"><img src=${linkedin} /></a>
            <a href="https://www.instagram.com/sequentuminc/" target="_blank"><img src=${instagram} /></a>
        </div>
    </div>
    `;
    }

    static styles = css`
        :host([hidden]) {
            display: none;
        }
        :host {
            display: flex;
            flex-direction: column;
            height: 100%;
            font-family: Inter;
            background-image: ${unsafeCSS(`url(${backgroundMaze})`)};
            background-size: cover;
        }
        :host * {
            box-sizing: border-box;
        }
        .header-logo {
            width: 165px;
            height: fit-content;
            margin: 27px;
        }
        .editor {
            display: flex;
            flex-direction: column;
            margin: auto;
            width: fit-content;
            min-height: 0px;
            padding-top: 0px;
            border-radius: 5px;
        }
        .link {
            color: var(--color-purple-dark);
            text-decoration: none;
        }
        .loginLink {
            display: flex;
            justify-content: center;
            padding: 10px;
            font: var(--font-button);
        }
        .loginButton {
            margin-top: 10px;
        }
        .scroll-container {
            min-height: 0px;
            overflow: auto;
            background-color: white;
            box-sizing: border-box;
            border-radius: 24px;
            padding: 40px 30px;
        }
        .content {
            width: 300px;
            margin: auto;
            display: flex;
            flex-direction: column;
        }
        .inputEditor {
            width: 100%;
            margin-bottom: 10px;
        }
        .email-container {
            display: flex;
            align-items: center;
            width: 100%;
            margin-bottom: 16px;
        }
        .email-text {
            margin: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
            font: var(--font-h4);
            color: var(--color-text);
        }
        .footer {
            color: rgba(83, 86, 122, 1);
            font: var(--font-small);
            padding: 0px 20px 10px 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .footer a {
            color: rgba(83, 86, 122, 1);
            text-decoration: none;
        }
        .footer a:hover {
            color: var(--color-secondary);
            text-decoration: none;
        }
    `;
}
